import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, Select } from 'tea-component';
import { connect, useHistory, useIntl } from 'umi';

function VersionSelection({ visible, close, versionUrl, wholeGameInfo }: any) {
  const { formatMessage } = useIntl();
  const [value, setValue] = useState<any>('');
  const history = useHistory();
  const [opinionMobileList, defaultGameId] = useMemo(() => {
    let mobileEditionList = wholeGameInfo?.mobile_edition_list || [];
    return [
      mobileEditionList.map((item: any) => ({
        value: item.edition_unified_id,
        text: (
          <div className="dbo-version-item">
            <img src={item.cover} className="dbo-version-item-img" />
            <div className="dbo-version-item-text">{item.entity_name}</div>
          </div>
        ),
      })),
      mobileEditionList?.[0]?.edition_unified_id,
    ];
  }, [wholeGameInfo]);

  useEffect(() => {
    setValue(defaultGameId);
  }, [defaultGameId]);

  return (
    <Modal
      visible={visible}
      size={500}
      caption={formatMessage({ id: 'Version Selection' })}
      onClose={close}
      className="dbo-stats-version-modal"
    >
      <Modal.Body>
        <div className="dbo-version-text">
          {formatMessage({ id: 'Please choose an edition first.' })}
        </div>
        <Select
          appearance="button"
          options={opinionMobileList}
          value={value}
          matchButtonWidth
          className="dbo-stats-selectbox"
          listHeight={244}
          boxClassName="dbo-stats-selectbox-box"
          onChange={(value) => setValue(value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => {
            history.push(versionUrl + `?gameid=${value}`);
          }}
        >
          {formatMessage({ id: 'Confirm' })}
        </Button>
        <Button type="weak" onClick={close}>
          {formatMessage({ id: 'Cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(VersionSelection);
